import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { DisclosureBanner } from "../components/DisclosureBanner";
import { LegalLayout } from "./LegalLayout";
import { useLegalSEO } from "../lib/useLegalSEO";

const Disclosure = () => {
    useLegalSEO({
        title: "Affiliate Disclosure | Better Rest Report",
        description:
            "Our affiliate disclosure under FTC 16 CFR Part 255 — how we use affiliate links, why, and our commitment to editorial independence.",
        path: "/disclosure",
    });
    return (
    <div className="App">
        <DisclosureBanner variant="top" />
        <Header />
        <LegalLayout
            kicker="Transparency"
            title="Affiliate Disclosure"
            updated="Last updated: December 2025"
            testId="page-disclosure"
        >
            <p>
                In accordance with U.S. Federal Trade Commission (FTC)
                guidelines (16 CFR Part 255) regarding endorsements and
                testimonials in advertising, we want our readers to be fully
                informed about the nature of our financial relationships
                with the products and services we cover.
            </p>

            <h2>1. We Use Affiliate Links</h2>
            <p>
                SleepComfortReport.com and the Better Rest Report
                participate in affiliate marketing programs, including the
                ClickBank affiliate network. This means that when you click
                certain links on our Site and complete a qualifying purchase
                or action on the third-party site, we may receive a
                commission. This is at <strong>no additional cost</strong>{" "}
                to you.
            </p>

            <h2>2. Why We Use Them</h2>
            <p>
                Affiliate commissions help fund the editorial work behind
                this site — the research, the photography, the writing, and
                the cost of keeping the lights on. We are grateful when
                readers choose to support us by purchasing through our
                links.
            </p>

            <h2>3. Editorial Independence</h2>
            <p>
                Our editorial opinions, reviews, and recommendations are our
                own, and are not influenced by affiliate commissions or
                advertiser payments. We do not write about products we do
                not find genuinely interesting, and the presence of an
                affiliate link does not change our review or
                recommendation.
            </p>

            <h2>4. "Advertisement" Labeling</h2>
            <p>
                Where required, content on this Site is clearly labeled as
                "Advertisement" or "Advertorial" at the top of the page and
                in the footer. Articles and pages that include affiliate
                links are presumed to be sponsored content for the purposes
                of disclosure.
            </p>

            <h2>5. No Medical Claims</h2>
            <p>
                The products covered on this Site are consumer lifestyle
                products. Nothing on this Site is intended to diagnose,
                treat, cure, or prevent any disease or health condition.
                Always consult a qualified professional for health
                concerns.
            </p>

            <h2>6. Pricing & Availability</h2>
            <p>
                Prices, availability, and product details on third-party
                merchant sites can change at any time and are controlled by
                the merchant, not by us. Please verify all details on the
                merchant's site before purchasing.
            </p>

            <h2>7. Questions</h2>
            <p>
                If you have any questions about our affiliate relationships,
                please reach out via our <a href="/contact">Contact</a>{" "}
                page.
            </p>
        </LegalLayout>
        <Footer />
    </div>
    );
};

export default Disclosure;
